<template>
	<el-dialog title="转账" :visible.sync="visible" width="480px" :close-on-click-modal="false" @close="onClose">
		<el-form :model="form" :rules="rules" ref="transferForm" label-width="100px">
			<!-- 转账对象 (仅私聊可用) -->
			<el-form-item label="转账给" v-if="receiverName">
				<div class="receiver-info">
					<i class="el-icon-user"></i>
					<span>{{ receiverName }}</span>
				</div>
			</el-form-item>

			<!-- 转账金额 -->
			<el-form-item label="转账金额" prop="amount">
				<el-input v-model.number="form.amount" placeholder="请输入金额" type="number" step="0.01" autofocus>
					<template slot="prepend">¥</template>
				</el-input>
			</el-form-item>

			<!-- 转账备注 -->
			<el-form-item label="转账说明" prop="remark">
				<el-input v-model="form.remark" placeholder="请输入转账说明（可选）" maxlength="30" show-word-limit></el-input>
			</el-form-item>

			<!-- 支付密码 -->
			<el-form-item label="支付密码" prop="payPassword">
				<el-input v-model="form.payPassword" placeholder="请输入支付密码" type="password" show-password
					maxlength="6"></el-input>
			</el-form-item>

			<!-- 金额提示 -->
			<div class="amount-tip">
				<i class="el-icon-info"></i>
				<span>对方24小时内未领取将自动退回</span>
			</div>
		</el-form>

		<div slot="footer" class="dialog-footer">
			<el-button @click="onClose">取消</el-button>
			<el-button type="primary" @click="onSubmit" :loading="loading">
				{{ loading ? '转账中...' : '确认转账' }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "TransferSend",
	props: {
		toUserId: {
			type: Number, // 接收方用户ID
			required: true
		},
		receiverName: {
			type: String, // 接收方昵称
			default: ''
		}
	},
	data() {
		const validateAmount = (rule, value, callback) => {
			if (!value || value <= 0) {
				callback(new Error('请输入有效的金额'));
			} else if (value < 0.01) {
				callback(new Error('转账金额至少0.01元'));
			} else {
				callback();
			}
		};

		return {
			visible: false,
			loading: false,
			form: {
				amount: null, // 转账金额
				remark: '', // 转账备注
				payPassword: '' // 支付密码
			},
			rules: {
				amount: [
					{ required: true, message: '请输入金额', trigger: 'blur' },
					{ validator: validateAmount, trigger: 'blur' }
				],
				remark: [
					{ max: 30, message: '转账说明不能超过30个字符', trigger: 'blur' }
				],
				payPassword: [
					{ required: true, message: '请输入支付密码', trigger: 'blur' },
					{ min: 6, max: 6, message: '支付密码为6位数字', trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		open() {
			this.visible = true;
			this.resetForm();
		},
		onClose() {
			this.visible = false;
			this.resetForm();
		},
		resetForm() {
			this.form = {
				amount: null,
				remark: '',
				payPassword: ''
			};
			if (this.$refs.transferForm) {
				this.$refs.transferForm.clearValidate();
			}
		},
		async onSubmit() {
			try {
				// 表单验证
				await this.$refs.transferForm.validate();

				this.loading = true;

				// 调用发送转账API
				const res = await this.$http({
					url: '/transfer/send',
					method: 'POST',
					data: {
						toUserId: this.toUserId,
						amount: this.form.amount,
						remark: this.form.remark || '',
						payPassword: this.form.payPassword
					}
				});

				this.$message.success('转账成功');
				this.$emit('success', res);
				this.onClose();

			} catch (error) {
				if (error.message) {
					this.$message.error(error.message);
				}
			} finally {
				this.loading = false;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.receiver-info {
	display: flex;
	align-items: center;
	padding: 10px;
	background: #f4f4f5;
	border-radius: 4px;
	font-size: 14px;
	color: #606266;

	i {
		margin-right: 8px;
		font-size: 18px;
		color: #409EFF;
	}
}

.tip-text {
	margin-left: 10px;
	font-size: 12px;
	color: #909399;
}

.amount-tip {
	padding: 12px;
	background: #fff3e0;
	border-radius: 4px;
	margin-bottom: 20px;
	font-size: 13px;
	color: #606266;
	display: flex;
	align-items: center;

	i {
		margin-right: 8px;
		color: #ff9800;
		font-size: 16px;
	}
}

::v-deep .el-dialog__body {
	padding: 20px 20px 0;
}
</style>

